// @flow

import styled from 'styled-components';

export const VoucherText = styled.p`
  margin-top: 0.6em 0;
  font-family: ${props => props.theme.fontFamily.sansSerif};
  color: ${props => props.theme.colors.secondaryGray};
  ${props => props.onlyItem == true ? 'text-align: center' : ''}
`;
